// tslint:disable
export var AccountContactInformationPurposeType;
(function (AccountContactInformationPurposeType) {
    // UNKN
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["UNKN"] = 0] = "UNKN";
    // MAIN
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["MAIN"] = 1] = "MAIN";
    // MKTG
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["MKTG"] = 2] = "MKTG";
    // SALES
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["SALES"] = 3] = "SALES";
    // CUSTSER
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["CUSTSER"] = 4] = "CUSTSER";
    // HOME
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["HOME"] = 5] = "HOME";
    // WORK
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["WORK"] = 6] = "WORK";
    // SEAS
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["SEAS"] = 7] = "SEAS";
    // OTHR
    AccountContactInformationPurposeType[AccountContactInformationPurposeType["OTHR"] = 8] = "OTHR";
})(AccountContactInformationPurposeType || (AccountContactInformationPurposeType = {}));
//# sourceMappingURL=AccountContactInformationPurposeType.js.map